import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

const Iconify = forwardRef(({ icon, width = 20, sx, ...other }, ref) => {
  // Fallback icon if the main icon fails to load
  const fallbackIcon = 'eva:circle-fill';

  return (
    <Box
      ref={ref}
      component={Icon}
      className="component-iconify"
      icon={icon || fallbackIcon}
      sx={{
        width,
        height: width,
        display: 'block', // Ensure icon is always visible
        ...sx,
      }}
      {...other}
    />
  );
});

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  width: PropTypes.number,
};

export default Iconify;
